import Serializable from "@/core/misc/mixins/Serializable";
import Core from "@/core/Core";

class PaymentPriorityType extends Serializable {
    public id: number;
    public name: string;
    public number: number;
    public sortField: number;

    /** 0. Суд, лишение отсрочки */
    get fullName(): string {
        if (Core.utils.isNullOrUndefined(this.number)) {
            return this.name;

        } else {
            return `${this.number}. ${this.name}`;
        }
    }

    /** Представление в селектах (VSelectV2 рендерит toString) */
    toString(): string {
        return this.fullName;
    }

    static fromServer(data: any, result = new PaymentPriorityType()): PaymentPriorityType {
        return super.fromServer(data, result);
    }
}

export default PaymentPriorityType;